<template>
  <div ref="el">
    <slot />
  </div>
</template>

<script setup>
import useAnimationFrame from "#blokkli/helpers/composables/useAnimationFrame";
import {
  useBlokkli,
  ref,
  computed,
  onMounted,
  onBeforeUnmount,
  watch
} from "#imports";
const props = defineProps({
  id: { type: String, required: true }
});
const { ui } = useBlokkli();
const x = ref(0);
const y = ref(0);
const width = ref(0);
const height = ref(0);
const rect = computed(() => {
  return {
    x: x.value,
    y: y.value,
    width: width.value,
    height: height.value
  };
});
const el = ref(null);
useAnimationFrame(() => {
  if (!el.value) {
    return;
  }
  const rect2 = el.value.getBoundingClientRect();
  x.value = rect2.x;
  y.value = rect2.y;
  width.value = rect2.width;
  height.value = rect2.height;
});
watch(rect, (v) => {
  ui.setViewportBlockingRectangle(props.id, v);
});
onMounted(() => {
  ui.setViewportBlockingRectangle(props.id, rect.value);
});
onBeforeUnmount(() => {
  ui.setViewportBlockingRectangle(props.id);
});
</script>
